<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeModal">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if (formLoaded) {
		<form (ngSubmit)="submit($event)" class="fade-in">
			<div class="modal-body">
				<div class="char-data__group">
					<rl-form-table-row [labelText]="'Party Name'" [required]="true"
						[class.has-error]="form.controls.partyName.touched && form.invalid && form.controls.partyName.value === ''">
						<ng-template rlFormTableControl>
							<rl-text-input [formControl]="form.controls.partyName"
								[dataLabel]="'textInputPartyName'"></rl-text-input>
						</ng-template>
						@if (form.controls.partyName.touched && form.invalid && form.controls.partyName.value === '') {
							<ng-template rlFormTableMessage>
								Party Name is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Party Description'" [required]="true"
						[class.has-error]="form.controls.partyDescription.touched && form.invalid && form.controls.partyDescription.value === ''">
						<ng-template rlFormTableControl>
							<rl-text-area [formControl]="form.controls.partyDescription" [styles]="{maxLength: 10000}"
								[dataLabel]="'textareaInputDescription'"></rl-text-area>
						</ng-template>
						@if (form.controls.partyDescription.touched && form.invalid && form.controls.partyDescription.value === '') {
							<ng-template rlFormTableMessage>
								Party Description is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'System Indicator'">
						<ng-template rlFormTableControl>
							<rl-number-input [formControl]="form.controls.systemIndicatorId"
								[dataLabel]="'numberInputSystemIndicator'"></rl-number-input>
						</ng-template>
					</rl-form-table-row>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="cancelButton">Cancel</button>
				<button type="submit" class="btn btn-success" [disabled]="form.invalid || isSaving"
					data-cy="saveButton">Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="3"></rl-form-placeholder>
		</div>
	}
</div>